var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.showDocs && _vm.showOpenAccountForm && _vm.currentMeeting && !_vm.waitingForProcess)?_c('MeetingDetailsOpenAccount'):(_vm.currentMeeting)?_c('MeetingDetailsInfo'):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }